/** Wait for owner-scoped persistence before removing rows; failed requests stay retryable. */
export async function hideFundingHistoryOperation(client, cache, id) {
    await client.hideHistoryOperation(id);
    const histories = {
        queryKey: ['onramp', client.cacheKey, 'history'],
        predicate: (query) => query.queryKey.length === 5,
    };
    // Cancel older reads so a response started before the write cannot restore a hidden row.
    await cache.cancelQueries(histories);
    cache.setQueriesData(histories, (previous) => previous && {
        ...previous,
        pages: previous.pages.map((page) => ({
            ...page,
            data: page.data.filter((operation) => operation.id !== id),
        })),
    });
    await cache.invalidateQueries(histories);
}
